// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".owner[data-v-7f9d219c]{color:#d1d1d1;font-style:italic;margin:20px auto 0;text-align:center;width:400px}.underconstruction[data-v-7f9d219c]{background:#f1f5f6;margin:auto;padding:20px 40px;text-align:center}.underconstruction h1[data-v-7f9d219c]{font-size:1.5rem}.outer[data-v-7f9d219c]{height:100%;margin-top:50px;width:100%}.middle[data-v-7f9d219c]{margin:0 auto}.inner[data-v-7f9d219c]{margin-left:auto;margin-right:auto;width:400px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
